import { useState } from "react";
import "../../styles/header.css";
import { ShareMenu } from "./share-menu";

const Header = () => {
  const [shareMenuOpen, setShareMenuOpen] = useState<boolean>(false);

  const handleShareMenuOpen = () => {
    setShareMenuOpen(!shareMenuOpen);
  };

  const handleShareMenuClose = () => {
    setShareMenuOpen(false);
  };
  return (
    <div id="header">
      <div className="header-layout">
        <div className="hedaer-title">
          <span>BİR</span>
          &nbsp;
          <span
            style={{
              fontWeight: 800,
            }}
          >
            BUNDLE
          </span>
          &nbsp;
          <span
            style={{
              fontWeight: 800,
              color: "var(--bundle-red)",
            }}
          >
            AI
          </span>
          &nbsp;
          <span
            style={{
              fontWeight: 800,
            }}
          >
            STUDIO
          </span>
          &nbsp;
          <span>PROJESİ</span>
          <div className="flexible">
            <img src="./images/info.png" alt="info" />
          </div>
        </div>
        <div className="header-share-container">
          <button onClick={handleShareMenuOpen} className="header-share">
            <span>Paylaş</span>
            <img src="./images/share.png" alt="info" />
          </button>
          <ShareMenu
            menuOpen={shareMenuOpen}
            handleMenuClose={handleShareMenuClose}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
